module.exports = __webpack_public_path__ + "img/brightscreen_300.07646d63.png";